export const links = {
        linkedin: "https://www.linkedin.com/in/vikram-singh-32b0b2119/",
        github: "https://github.com/vikramsingh13",
        codepen: "https://codepen.io/vikramsingh13",
        resume: "https://drive.google.com/file/d/1CDURmBFhxGZF4NSt7U_z0Ev_xaqvUWR7/view?usp=drive_link",
        
};